export const cardTheme = {
  baseStyle: {
    container: {
      boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
      borderRadius: 0
    }
  }
}
